import styled from "styled-components";
export const ModalContent = styled.div`
  background: white;
  color: rgb(10 92 86);
  padding: 1.5rem;
  border-radius: 8px;
  width: 90%; /* take most of the width on small screens */
  max-width: 600px; /* don’t let it stretch too wide */
  display: flex;
  flex-direction: column;
  gap: 0.8rem;

  @media (min-width: 768px) {
    width: 70%; /* tablet */
    padding: 2rem;
  }

  @media (min-width: 1200px) {
    width: 40%; /* desktop */
    padding: 2rem 3rem;
  }
`;

export const InputWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Label = styled.label`
  font-size: 0.8rem;
  font-weight: 500;
  color: rgb(10 92 86);
  margin-bottom: 5px;
`;

export const Input = styled.input`
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  outline: none;
  transition: border 0.2s, box-shadow 0.2s;
  color: #333;

  &:focus {
    border-color: #1f8560ff;
    box-shadow: 0 0 0 2px rgba(21, 149, 96, 0.2);
  }
`;

export const ButtonRow = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 10px;
  margin-top: 0.7rem;
`;

export const CancelButton = styled.button`
  width: 40%;
  padding: 14px;
  border-radius: 6px;
  background-color: #e5e7eb;
  color: #111;
  font-weight: 500;
  cursor: pointer;
  border: none;

  &:hover {
    background-color: #d1d5db;
  }
`;

export const ConfirmButton = styled.button`
  width: 40%;
  padding: 8px 16px;
  border-radius: 6px;
  background-color: #0f6f64ff;
  color: white;
  font-weight: 500;
  cursor: pointer;
  border: none;

  &:hover {
    background-color: rgb(10 92 86);
  }
`;

export const Select = styled.select`
  width: 100%;
  padding: 10px;
  border-radius: 6px;
  border: 1px solid #ccc;
  font-size: 1rem;
  background-color: #fff;
  color: #333;
  outline: none;
  transition: background-color 0.2s, border-color 0.2s;
  cursor: pointer;

  &:focus {
    border-color: #1f8560ff;
    box-shadow: 0 0 0 2px rgba(21, 149, 96, 0.2);
  }
`;

export const Option = styled.option`
  font-size: 1rem;
  padding: 0.5rem;
`;
